import { render, staticRenderFns } from "./pageination.vue?vue&type=template&id=675fbf9a"
import script from "./pageination.vue?vue&type=script&lang=js"
export * from "./pageination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports